import parse from 'csv-parse';

// TEA ships three sibling listings in this header family: the November preliminary listing,
// the Final spring listing, and the grades 9-11 planning listing. Only the Final listing is the
// accountability population, so detection requires BOTH the exact header and the `Final` filename
// token. The accountability year is read from the filename's `_(\d{4})_` segment (the file content
// has no accountability-year column to cross-check); if it is absent we treat the file as NOT this
// type rather than guessing.
const AcceleratedTestersColumns = [
  'District Number',
  'Campus Number',
  'Campus Name',
  'TSDS Unique ID',
  'Local Student ID',
  'Student Name',
  'Date of Birth',
  'Subject',
  'Criteria',
  'Year',
  'Grade',
  'SAT or ACT',
];

const isAcceleratedTesters = (file) =>
  new Promise((resolve) => {
    if (file.type != 'application/vnd.ms-excel' && file.type != 'text/csv') {
      resolve({ isValid: false });
      return;
    }
    if (!/Accelerated_Testers_Final/i.test(file.name || '')) {
      resolve({ isValid: false });
      return;
    }
    const yearMatch = (file.name || '').match(/_(\d{4})_/);
    if (!yearMatch) {
      resolve({ isValid: false });
      return;
    }
    const year = yearMatch[1];
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      // TEA ships these files with CRLF endings and a trailing blank line; without
      // skip_empty_lines/relax_column_count the default parser throws Invalid Record
      // Length on that blank row and the file is silently reported "Unrecognized".
      // We only need the header row, so be lenient about the body.
      parse(text, { skip_empty_lines: true, relax_column_count: true, trim: true }, (err, output) => {
        if (err) {
          resolve({ isValid: false });
          return;
        }
        if (output && output[0] && JSON.stringify(output[0]) === JSON.stringify(AcceleratedTestersColumns)) {
          resolve({ isValid: true, year });
        } else {
          resolve({ isValid: false });
        }
      });
    };
    reader.readAsText(file);
  });

export default isAcceleratedTesters;
